import { KeyframeConfig } from "../../../models/animations.model";

export const getZoomInBaseKeyframe = (
  scaleX: number,
  scaleY: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            scaleX: 0,
            scaleY: 0,
            originX: "center",
            originY: "center",
          },
          {
            scaleX,
            scaleY,
            originX: "center",
            originY: "center",
          },
        ],
      },
    },
  ];
};

export const getZoomOutBaseKeyframe = (
  scaleX: number,
  scaleY: number
): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          {
            scaleX,
            scaleY,
            originX: "center",
            originY: "center",
          },
          {
            scaleX: 0,
            scaleY: 0,
            originX: "center",
            originY: "center",
          },
        ],
      },
    },
  ];
};
